var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "bearse-features" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-4" },
        [
          _c("transition", { attrs: { name: "fade", appear: "" } }, [
            _c(
              "div",
              { staticClass: "card", staticStyle: { "min-height": "310px" } },
              [
                _c("div", { staticClass: "card-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center"
                    },
                    [
                      _vm._v(
                        "\n              bearse feature " +
                          _vm._s(_vm.activeFeature) +
                          "\n              "
                      ),
                      _c(
                        "div",
                        { staticClass: "nav-item btn-group dropdown" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn-block btn dropdown-toggle btn-secondary",
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.activeFeature) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "dropdown-menu dropdown-menu-right scrollable-menu"
                            },
                            [
                              _c("h6", { staticClass: "dropdown-header" }, [
                                _vm._v("Bearse Features")
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.listFeaturesWithCount(
                                  _vm.features,
                                  _vm.report
                                ),
                                function(feature) {
                                  return _c("div", { key: feature.name }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item d-flex",
                                        on: {
                                          click: function($event) {
                                            _vm.activeFeature = feature.name
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "15px"
                                            }
                                          },
                                          [_vm._v(_vm._s(feature.name))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "badge badge-pill ml-auto",
                                            class: [
                                              feature.count > 0
                                                ? "badge-primary"
                                                : "badge-secondary"
                                            ]
                                          },
                                          [_vm._v(_vm._s(feature.count))]
                                        )
                                      ]
                                    )
                                  ])
                                }
                              )
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("dl", [
                    _c("dt", [_vm._v("Latest Version")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.features[_vm.activeFeature].latest))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Minimum Version")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.features[_vm.activeFeature].minimum))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Source")]),
                    _c("dd", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.features[_vm.activeFeature].source
                          }
                        },
                        [_vm._v(_vm._s(_vm.features[_vm.activeFeature].source))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Open Source")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.features[_vm.activeFeature].opensource))
                    ])
                  ])
                ])
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-8" },
        [
          _c(
            "transition",
            { attrs: { name: "fade", appear: "" } },
            [
              _c("vue-good-table", {
                attrs: {
                  columns: _vm.accountsTable,
                  rows: _vm.accounts,
                  "pagination-options": {
                    enabled: true,
                    perPage: 5
                  },
                  styleClass: "vgt-table condensed"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c("vue-good-table", {
            attrs: {
              columns: _vm.featureTable,
              rows: _vm.selectFeature(_vm.report, _vm.activeFeature),
              "search-options": {
                enabled: true,
                skipDiacritics: true,
                placeholder: "filter"
              },
              "pagination-options": {
                enabled: true,
                perPage: 20
              },
              styleClass: "vgt-table condensed"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-766da2e7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-766da2e7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/BearseFeatures.vue
// module id = null
// module chunks = 